import { useTranslation } from 'next-i18next';

import { useAccountT } from '@/shared/i18n/useAccountT';

export const useGetSchoolTypeOptions = (): {
  label: string;
  value: string;
}[] => {
  const { t } = useTranslation(['common']);
  const accountT = useAccountT();

  return [
    { label: t('common:school.level.kindergarten'), value: 'KINDERGARTEN' },
    { label: t('common:school.level.primary'), value: 'PRIMARY' },
    { label: t('common:school.level.middle'), value: 'MIDDLE' },
    { label: t('common:school.level.high'), value: 'HIGH' },
    { label: accountT('account:school.level.college'), value: 'COLLEGE' },
    { label: t('common:school.level.other'), value: 'OTHER' },
  ];
};

export const useGetUsagePurposeOptions = (): {
  label: string;
  value: string;
}[] => {
  const accountT = useAccountT();

  return [
    {
      label: accountT('account:signup.company.purpose1'),
      value: 'company_purpose_1',
    },
    {
      label: accountT('account:signup.company.purpose2'),
      value: 'company_purpose_2',
    },
    {
      label: accountT('account:signup.company.purpose3'),
      value: 'company_purpose_3',
    },
    {
      label: accountT('account:signup.company.purpose4'),
      value: 'company_purpose_4',
    },
    {
      label: accountT('account:signup.company.purpose5'),
      value: 'company_purpose_5',
    },
  ];
};
